import FSearchGridMDP from "@/components/generic/FSearchGridMDP"

import VerifiedClientListFDataTableMDP from "./VerifiedClientListFDataTableMDP";
import VerifiedClientListDateSearchFFormMDP from "./VerifiedClientListDateSearchFFormMDP";

export default class VerifiedClientListFSearchGridMDP extends FSearchGridMDP {
    constructor(props: {parent: any;taskRoot: any}) {
        super({
            gridMDP: new VerifiedClientListFDataTableMDP({parent: props.parent}),
            searchFormMDP: new VerifiedClientListDateSearchFFormMDP({parent: props.parent}),
            myRefName: "verifiedClientListFSearchGridRef",
            onSearch: () => props.parent.getOnboardedFileList(),
            onClear: props.parent.clearFilter()
        })
    }
}